import InkSignature from './InkSignature';

export default InkSignature;